/* eslint-disable comma-dangle */
/* eslint-disable semi */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import axios from 'axios'
// import {getToken} from '@/utils/auth'
// import {Message} from 'element-ui';
import {Notify, Toast} from 'vant'
import {getClientData} from '@/utils/user'

/**
 * 使用自定义配置新建一个 axios 实例
 * baseURL = 请求路径
 * timeout = 请求超时配置
 */
const request = axios.create({
  baseURL: process.env.BASE_API,
  timeout: process.env.TIME_OUT,
})
// let timer = false
let toast = null

let ContentType = {
  'json': 'application/json;charset=utf-8',
  'formData': 'application/x-www-form-urlencoded'
}

/**
 * request拦截器
 * 可以在这里添加 Header 头部信息，等
 */
request.interceptors.request.use(config => {
  // console.log('拦截请求config：' + JSON.stringify(config))
  // 添加请求头信息，处理安全性问题
  config.headers.Authorization = 'Basic dnVlOnZ1ZQ=='
  // 添加时间戳防止IE不刷新页面
  if (config.method == 'post' && config.dataType != 'formData') {
    config.data = config.data
    // config.data = {
    //   ...config.data
    //   // _t: Date.parse(new Date()) / 1000,
    // }
  } else if (config.method == 'get') {
    config.params = {
      // _t: Date.parse(new Date()) / 1000,
      ...config.params
    }
  }

  config.headers = {
    'Content-Type': ContentType[config.dataType ? config.dataType : 'json'],
    'appId': getClientData().appId ? getClientData().appId : "", // process.env.APPID,
    'clientType': getClientData().clientType ? getClientData().clientType:"", // process.env.CLIENTTYPE,
    'industryId': getClientData().industryId ? getClientData().industryId:"", // process.env.INDUSTRYID,
    'accessToken': getClientData().accessToken ? getClientData().accessToken:"", // config.accessToken ? config.accessToken : 'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySWQiOjI2NDUsImlzcyI6Inhod2wiLCJpYXQiOjE2MzkzODU4MjJ9.HOQ4FQDmgixv3Ct51HfBVwLp27ieJxwokKEnc25LxYBibay8pebVHnDSTxrAmCtFjuqS3SKEpxB5jaMcPZ9BQQ'
  }

  // config.headers = {
  //   'Content-Type': ContentType[config.dataType ? config.dataType : 'json'],
  //   'appId': process.env.APPID, // process.env.APPID,
  //   'clientType': process.env.CLIENTTYPE, // process.env.CLIENTTYPE,
  //   'industryId': process.env.INDUSTRYID, // process.env.INDUSTRYID,
  //   'accessToken': 'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySWQiOjgxMzEsImlzcyI6Inhod2wiLCJpYXQiOjE2NDA2Nzg3NjB9.gO6ObSZ_M8CG_4FONg24FdSk6EGn33FnvuZ9nWps7Bmjf0NUpnJCNeZyXvP1tVqBWR9HW3DzzYyjyQ9ovT7kyA'
  // }

  toast = Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    message: '加载中...',
  });
  return config
}, error => {
  // 处理请求错误
  Promise.reject(error)
})

function disResponse (response) {
  if (response.data.data != '' && response.data.data != undefined) {
    return response.data.data
  } else {
    return response.data.message
  }
}

/**
 * 下面的注释为通过response自定义code来标示请求状态，当coBASE_APIde返回如下情况为权限有问题，登出并返回到登录页
 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
 */
request.interceptors.response.use(
  response => {
    Toast.clear();
    // 请求成功处理
    const res = response.data
    // if (response.request.responseURL.indexOf('OpenDoor') == -1 && response.request.responseURL.indexOf('wyBase/login') == -1) {
    //   if (res.code != 200) {
    //     Notify({ type: 'warning', message: res.msg });
    //     return res
    //   }
    // }
    return res
  },
  error => {
    Toast.clear();
    // 处理请求错误
    // const response = error.response
    // if (response != undefined && response.data) {
    //   if (response.data.statusCode == '40206' && response.status == 400) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode == '40201' && response.status == 400) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode == '40202' && response.status == 400) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode == '40207' && response.status == 400) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode == '40208' && response.status == 400) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode == '40209' && response.status == 400) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode == '40203' && response.status == 400) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode == '401' && response.status == 401) {
    //     Notify({ type: 'warning', message: '凭证过期，请重新登录' });
    //     // Router.push('/')
    //   } else if (response.status == 500) {
    //     Notify({ type: 'warning', message: response.msg });
    //   } else if (response.data.statusCode != '200' && response.status != 200) {
    //     Notify({ type: 'warning', message: response.msg });
    //   }
    //   return response.data
    // } else if (response) {
    //   switch (response.status) {
    //     case 400:
    //       error.message = '错误的请求'
    //       break;
    //     case 401:
    //       Notify({ type: 'warning', message: '凭证过期，请重新登录' });
    //       break;
    //     case 403:
    //       Notify({ type: 'warning', message: '拒绝访问' });
    //       break;
    //     case 404:
    //       Notify({ type: 'warning', message: '请求错误,未找到该资源' });
    //       break;
    //     case 405:
    //       Notify({ type: 'warning', message: '请求方法未允许' });
    //       break;
    //     case 408:
    //       Notify({ type: 'warning', message: '请求超时' });
    //       break;
    //     case 500:
    //       Notify({ type: 'warning', message: '服务器端出错' });
    //       // Message({type: 'warning', message: ''})
    //       break;
    //     case 501:
    //       Notify({ type: 'warning', message: '网络错误，请检查网络' });
    //       break;
    //     case 502:
    //       Notify({ type: 'warning', message: '网络错误，请检查网络' });
    //       break;
    //     case 503:
    //       Notify({ type: 'warning', message: '服务不可用' });
    //       break;
    //     case 504:
    //       Notify({ type: 'warning', message: '网络请求超时' });
    //       break;
    //     case 505:
    //       Notify({ type: 'warning', message: 'http版本不支持该请求' });
    //       break;
    //     default:
    //       Notify({ type: 'warning', message: `连接错误${error.response.status}` });
    //   }
    // } else {
    //   Notify({ type: 'warning', message: error.message });
    // }
    // 弹出层
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js